import { useMemo, useState } from "react";
import HistoricalReportContext from "./historicalReportContext";

export const initialHistoricalReportState: HistoricalReportStateType = {
  tab: "YTD",
  eventOpen: false,
  filterType: "All Events",
};

const HistoricalReportProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const [historicalReportState, historicalReportSetState] =
    useState<HistoricalReportStateType>(initialHistoricalReportState);

  const historicalStateValue = useMemo(
    () => [{ historicalReportState, historicalReportSetState }],
    [historicalReportState, historicalReportSetState]
  );

  return (
    <HistoricalReportContext.Provider value={historicalStateValue}>
      {children}
    </HistoricalReportContext.Provider>
  );
};

export default HistoricalReportProvider;
